module.exports = __webpack_public_path__ + "img/PPG_LOGO_PICTO COUL.c25dc9c9.png";